import { render, staticRenderFns } from "./payment-link-form.vue?vue&type=template&id=980340a0&scoped=true&"
import script from "./payment-link-form.vue?vue&type=script&lang=js&"
export * from "./payment-link-form.vue?vue&type=script&lang=js&"
import style0 from "./payment-link-form.vue?vue&type=style&index=0&lang=css&"
import style1 from "./payment-link-form.vue?vue&type=style&index=1&id=980340a0&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "980340a0",
  null
  
)

export default component.exports